import { Routes } from '@angular/router';
import { Dashboard } from './pages/dashboard/dashboard';
import { Contents } from './pages/contents/contents';
import { Audiences } from './pages/audiences/audiences';
import { Comments } from './pages/comments/comments';
import { Settings } from './pages/settings/settings';
import { Contact } from './pages/contact/contact';
import { ContentCreation } from './pages/content-creation/content-creation';
import { CoachingList } from './pages/contents-list/coaching-list/coaching-list';
import { GpsOnlyList } from './pages/contents-list/gps-only-list/gps-only-list';
import { PlanningList } from './pages/contents-list/planning-list/planning-list';
import { PlaylistList } from './pages/contents-list/playlist-list/playlist-list';
import { ScenicList } from './pages/contents-list/scenic-list/scenic-list';
import { WorkoutList } from './pages/contents-list/workout-list/workout-list';
import { UploadHistory } from './pages/upload-history/upload-history';
import { canDeactivateFormGuard } from './guards/can-deactivate-form.guard';
import { uploadGuard } from './guards/upload-guard';
import { ContentDetails } from './pages/content-details/content-details';
import { UploadLayout } from './pages/upload-layout/upload-layout';
import { authGuard } from './guards/auth-guard-guard';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [authGuard],
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
      },
      {
        title: 'Content Creation',
        path: 'content-creation',
        component: ContentCreation,
        canDeactivate: [canDeactivateFormGuard],
      },
      {
        title: 'Upload',
        path: 'content-creation/upload',
        canActivate: [uploadGuard],
        component: UploadLayout,
      },
      {
        title: 'Dashboard',
        path: 'dashboard',
        component: Dashboard,
      },
      {
        title: 'Content',
        path: 'contents',
        component: Contents,
        children: [
          {
            path: '',
            redirectTo: 'scenic',
            pathMatch: 'full',
          },
          {
            title: 'Content Scenic',
            path: 'scenic',
            component: ScenicList,
          },
          {
            title: 'Content Coaching',
            path: 'coaching',
            component: CoachingList,
          },
          {
            title: 'Content Workout',
            path: 'workout',
            component: WorkoutList,
          },
          {
            title: 'Content Gps-only',
            path: 'gps-only',
            component: GpsOnlyList,
          },
          {
            title: 'Content Playlist',
            path: 'playlist',
            component: PlaylistList,
          },
          {
            title: 'Content Planning',
            path: 'planning',
            component: PlanningList,
          },
        ],
      },
      {
        title: 'Content Details',
        path: 'contents/:type/:id',
        component: ContentDetails,
      },
      {
        title: 'Content Edit',
        path: 'contents/:type/:id/edit',
        component: ContentCreation,
      },
      {
        title: 'Audiences',
        path: 'audiences',
        component: Audiences,
      },
      {
        title: 'Upload History',
        path: 'upload_history',
        component: UploadHistory,
      },
      {
        title: 'Comments',
        path: 'comments',
        component: Comments,
      },
      {
        title: 'Settings',
        path: 'settings',
        component: Settings,
      },
      {
        title: 'Contact',
        path: 'contact',
        component: Contact,
      },
    ],
  },
];
